import { useCallback, useContext, useState, } from 'react';
// TODO: (D.K.) Necessary make refactoring of this part of the functionality is needed (to get rid of react-redux)
// eslint-disable-next-line no-restricted-imports
import { useDispatch, useSelector } from 'react-redux';
import { setView360State, getView360State } from '@yme/pdp-components/ProductCard';
import { DigitalDataMutation, setDigitalData } from '@yme/utils/common';
import { GalleryItemType, keyCodes } from '@yme/utils/constants';
import { checkIsView360ButtonPressed } from './helpers';
const OFFSET_BOUNDARY = 5;
export const useGalleryHandlers = (context, isRightToLeft, isItemFirst, isItemLast, isOpenLightboxAvailable, openLightbox, currentIndex, setCurrentIndex, view360BtnRef) => {
    const [touchPosition, setTouchPosition] = useState(null);
    const [isDraggable, setIsDraggable] = useState(false);
    const isView360State = useSelector(getView360State);
    const dispatch = useDispatch();
    const { galleryData: { lightboxImagesList = [], thumbnailsList = [] }, currentId, } = useContext(context);
    const showNext = () => {
        setCurrentIndex((prev) => (prev !== null ? prev + 1 : prev));
    };
    const showPrev = () => {
        setCurrentIndex((prev) => (prev !== null ? prev - 1 : prev));
    };
    const showItem = useCallback((index) => {
        if (isView360State) {
            dispatch(setView360State(false));
        }
        const thumbnailTarget = thumbnailsList[index];
        if (thumbnailTarget) {
            if (thumbnailTarget.type === GalleryItemType.Action) {
                setDigitalData(DigitalDataMutation.PDP_CLICK_THUMBNAIL, {
                    id: thumbnailTarget.id,
                });
            }
        }
        setCurrentIndex(index);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [setCurrentIndex, isView360State, thumbnailsList]);
    const touchStartHandler = useCallback((event) => {
        if (isView360State) {
            return;
        }
        const touchDown = 'touches' in event ? event.touches[0].clientX : event.clientX;
        setTouchPosition(touchDown);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isView360State]);
    const touchMoveHandler = useCallback((event) => {
        if (isView360State || touchPosition === null || ('button' in event && event.button !== 0)) {
            return;
        }
        const currentTouch = 'touches' in event ? event.touches[0].clientX : event.clientX;
        const diff = touchPosition - currentTouch;
        const isMoveRight = diff < -OFFSET_BOUNDARY;
        const isMoveLeft = diff > OFFSET_BOUNDARY;
        const isShowPrevCase1 = !isRightToLeft && isMoveRight && !isItemFirst;
        const isShowPrevCase2 = isRightToLeft && isMoveLeft && !isItemFirst;
        const isShowNextCase1 = !isRightToLeft && isMoveLeft && !isItemLast;
        const isShowNextCase2 = isRightToLeft && isMoveRight && !isItemLast;
        const isOpenLightBox = Math.floor(diff) === 0 && isOpenLightboxAvailable;
        if (isShowPrevCase1 || isShowPrevCase2) {
            showPrev();
        }
        if (isShowNextCase1 || isShowNextCase2) {
            showNext();
        }
        if (isOpenLightBox) {
            const index = lightboxImagesList.findIndex(({ id }) => id === currentId);
            openLightbox(index);
        }
        setTouchPosition(null);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [touchPosition, currentIndex, openLightbox, isOpenLightboxAvailable, isView360State]);
    const pointerDownHandler = useCallback((event) => {
        if (checkIsView360ButtonPressed(view360BtnRef, event) || isView360State) {
            return;
        }
        event.preventDefault();
        setIsDraggable(true);
        touchStartHandler(event);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [touchStartHandler, isView360State]);
    const pointerUpHandler = useCallback((event) => {
        if (checkIsView360ButtonPressed(view360BtnRef, event) || isView360State) {
            return;
        }
        setIsDraggable(false);
        touchMoveHandler(event);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [touchMoveHandler, isView360State]);
    const arrowPressHandler = useCallback((event) => {
        if (isView360State) {
            return;
        }
        const isLeftArrow = event.key === keyCodes.ARROW_LEFT;
        const isRightArrow = event.key === keyCodes.ARROW_RIGHT;
        const isShownPrevCase1 = !isRightToLeft && isLeftArrow && !isItemFirst;
        const isShownNextCase1 = !isRightToLeft && isRightArrow && !isItemLast;
        const isShownNextCase2 = isRightToLeft && isLeftArrow && !isItemLast;
        const isShownPrevCase2 = isRightToLeft && isRightArrow && !isItemFirst;
        if (isShownPrevCase1 || isShownPrevCase2) {
            showPrev();
        }
        if (isShownNextCase1 || isShownNextCase2) {
            showNext();
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [showNext, showPrev, isItemLast, isItemFirst]);
    const enterPressHandler = useCallback((event) => {
        const isOpenLightBox = isOpenLightboxAvailable && event.key === keyCodes.ENTER;
        if (currentIndex !== null && isOpenLightBox) {
            openLightbox(currentIndex);
        }
    }, [currentIndex, isOpenLightboxAvailable, openLightbox]);
    const keyPressHandler = useCallback((event) => {
        arrowPressHandler(event);
        enterPressHandler(event);
    }, [arrowPressHandler, enterPressHandler]);
    return {
        showNext,
        showPrev,
        showItem,
        touchStartHandler,
        touchMoveHandler,
        pointerDownHandler,
        pointerUpHandler,
        keyPressHandler,
        isView360State,
        isDraggable,
    };
};
